<template>
    <div class="vx-col md:w-full sm:w-auto" style="width: 300px !important;">
        <div class="vx-row md:w-full">

            <vx-tooltip class="position-icon" :text="$t('button.detailSms')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="popupActive=true"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.stopSms')" position="top" v-if="params.data.sendStatus === 1">
                <feather-icon icon="PauseIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.runSms')" position="top" v-if="params.data.sendStatus !== 1">
                <feather-icon icon="PlayIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="runSms"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top" v-if="params.data.sendStatus !== 1">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="params.data.sendStatus !== 1">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo"  title="Chi tiết SMS" :active.sync="popupActive">
            <p>
                {{params.data.message}}
            </p>
        </vs-popup>
    </div>
</template>

<script>

import {en, vi} from "vuejs-datepicker/dist/locale";

export default {
    name: 'CellRendererActions',

    data() {
        return {
            popupCancel: false,
            rejectReason: null,
            popupConfirm: false,
            en: en,
            vi: vi,
            selectDate: new Date(),
            selectTime: new Date(),
            popupActive:false,
        }
    },

    methods: {
        editRecord() {
            this.$router.push(`/user/info-news-sms?id=${this.params.data.id}`).catch(() => {
            })
        },

        runSms() {

            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận chạy SMS`,
                text: 'Bạn có chắc chắn chạy SMS này?',
                accept: this.runSmsAction,
                acceptText: "Chạy",
                cancelText: "Huỷ"
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: 'Bạn có chắc là muốn xóa bài viết này không?',
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            const url = this.params.data.status ? '/sms-message-config/delete/' : '/sms-message-config/delete/';
            this.$crm.get(url + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Xoá thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('DELETE_NEWS_FEED', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        runSmsAction() {
            this.$vs.loading()
            setTimeout( ()=> {
                this.$vs.loading.close()
            }, 2000);
            const url = this.params.data.status ? '/sms-message-config/send/' : '/sms-message-config/send/';
            this.$crm.get(url + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Chạy thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                //, true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        openPopupcancel() {
            this.popupCancel = true;
            this.rejectReason = null;
        },




        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
    }
}
</script>

<style scoped></style>

